var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',_vm._g({attrs:{"lang":_vm.lang,"type":"datetime","show-time-panel":"","width":"100%","input-class":"form-control","format":_vm.momentFormat,"disabled-date":_vm.dateIsOutOfBounds,"disabled-time":_vm.timeIsOutOfBounds,"time-picker-options":{
    start: '07:00',
    step: '00:15',
    end: '20:00',
  }},model:{value:(_vm.wrappedValue),callback:function ($$v) {_vm.wrappedValue=$$v},expression:"wrappedValue"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }